import { Box } from "@chakra-ui/react";
import React from "react";

import { Table, TableColumn } from "../../../../components";
import { SettingSwitch } from "./SettingSwitch";
import { SettingSwitchWithConfirmDialogue } from "./SettingSwitchWithConfirmDialogue";

export interface DisplayData {
  id: string;
  name: string;
  autoJoinAllNewPositions: boolean;
  atsOptInAllNewPositions: boolean;
}

interface RecordingSettingsAllFutureListProps {
  displayData: Array<DisplayData>;
  updatePositionsRecordingSettings: (
    ids: DisplayData[],
    autoJoinOnOff: boolean,
    optInOnOff: boolean
  ) => Promise<any>;
  showOptIn: boolean;
}

const RecordingSettingsAllFutureList: React.FC<
  RecordingSettingsAllFutureListProps
> = ({ displayData, updatePositionsRecordingSettings, showOptIn = false }) => {
  const columns: TableColumn[] = [
    {
      Header: "Future Positions",
      accessor: "name",
      Cell: (displayData) => <Box>All Future {displayData.name} Positions</Box>,
    },
    {
      Header: "Auto Join All New Positions",
      accessor: "autoJoinAllNewPositions",
      Cell: (displayData) => {
        return (
          <SettingSwitch
            onToggle={(newValue) =>
              updatePositionsRecordingSettings(
                [displayData],
                newValue,
                displayData.atsOptInAllNewPositions
              )
            }
            isChecked={displayData.autoJoinAllNewPositions}
          >
            {displayData.autoJoinAllNewPositions
              ? "Auto-join enabled"
              : "Auto-join disabled"}
          </SettingSwitch>
        );
      },
    },
  ];

  if (showOptIn) {
    const optInColumn: TableColumn = {
      Header: "Opt In All New Positions",
      accessor: "atsOptInAllNewPositions",
      Cell: (displayData) => {
        return (
          <SettingSwitchWithConfirmDialogue
            onToggle={(newValue) =>
              updatePositionsRecordingSettings(
                [displayData],
                displayData.autoJoinAllNewPositions,
                newValue
              )
            }
            isChecked={displayData.atsOptInAllNewPositions}
            shouldConfirm={!displayData.atsOptInAllNewPositions}
            headerText="Are you sure you want to enable opt-in consent for all positions?"
            headerBody={
              <>
                Enabling <strong>Opt In All New Positions</strong> will
                immediately apply opt-in rules to all active candidates that
                match this criteria. Any candidate not currently assigned to an
                opt-in position will be automatically marked as Opted Out, which
                may disrupt scheduling and generate a large volume of opt-out
                notification emails. This change may be difficult to reverse.
              </>
            }
            confirmButtonText="Proceed Anyways"
          >
            {displayData.atsOptInAllNewPositions
              ? "Opt-in consent"
              : "Opt-out consent"}
          </SettingSwitchWithConfirmDialogue>
        );
      },
    };
    columns.splice(columns.length - 1, 0, optInColumn);
  }

  return <Table w="1200px" mb={3} columns={columns} data={displayData} />;
};

export default RecordingSettingsAllFutureList;
